import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { AppRouter } from './routes/AppRouter';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ActivityBar } from './components/layout/ActivityBar';
import { ApiUnavailable } from './pages/ApiUnavailable/ApiUnavailable';
import { selectIsApiReachable } from './features/connection/connectionSlice';

/**
 * Router, unless there is no server to talk to.
 *
 * It sits **outside** the router on purpose: with the API down, the login is the
 * one screen with nothing mounted that could report the failure, and it is where
 * the current behaviour is worst — the form blames the user's password for a
 * missing backend.
 */
const RouterOrFallback = () => {
  const isApiReachable = useSelector(selectIsApiReachable);

  return isApiReachable ? <AppRouter /> : <ApiUnavailable />;
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          {/* Above the router, so the login and the public tracking get it too. */}
          <ActivityBar />
          <RouterOrFallback />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  );
}

export default App;
